import React from "react";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useQuery } from 'react-query';
import { getMedallists } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import MedallistsTable from "components/common/medals/MedallistsTable";
import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";
import Selector_Event from "components/common/selectors/SelectorEvent";
import { Stack } from "react-bootstrap";
import SelectorNoc from "components/common/selectors/selector-noc";
import SelectorMedal from "components/common/selectors/selector-medals";
import { ALL_URL,groupByDate } from "helpers/utils";
import SelectorDay from "components/common/selector-day/SelectorDay";
import Label from "components/general/Label";
import PageHeader from "components/common/PageHeader";

const Medallists = () => {
  const [dataState, setDataState] = React.useState([]);
  const [competitorFilter, setcompetitorFilter] = React.useState();


  const header = Label({ data: 'LabelMedallists' });
  const { mirs_competition, mirs_language, mirs_discipline, mirs_event, mirs_noc, mirs_medal,mirs_date } = useUrlFriendlyToParameters()

  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['medallists', mirs_competition, mirs_language],
      queryFn: getMedallists,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //enabled: !!confCategory
      onError: (error) =>
        console.error(`Something went wrong: ${error.message}`),
    });



  React.useEffect(() => {
    let filterData = data?.medallist
    if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
      filterData = filterData?.filter(item => item?.discipline?.code === mirs_discipline)
      if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT)
        filterData = filterData?.filter(item => item?.event_code === mirs_event)
    }
    if (mirs_noc && mirs_noc !== ALL_URL.ALL_NOC) {
      filterData = filterData?.filter(item => item?.participant?.organisation?.code === mirs_noc)
    }
    if (mirs_medal && mirs_medal !== ALL_URL.ALL_MEDAL) {
      filterData = filterData?.filter(item => item?.medal_type === mirs_medal)
    }

  	if (mirs_date && mirs_date !== ALL_URL.ALL_DAYS) {
      filterData = filterData?.filter(item => item?.medal_date === mirs_date)
    }
    
    if (competitorFilter) {
      filterData = filterData?.filter(item => item?.participant?.name?.toLowerCase().includes(competitorFilter.toLowerCase()));
    }

    //filterData = competitorFilter && filterData?.filter(item => item?.participant?.name?.toLowerCase().includes(competitorFilter.toLowerCase()));


    setDataState(filterData);
  }, [data, mirs_discipline, mirs_event, mirs_noc, mirs_medal, mirs_date, competitorFilter]);


  const handleOnChange = event => {
    const { name, value } = event.target;
    //et filterData = dataState
    //console.log(filterData)
    // filterData = filterData?.filter(item => item?.participant?.name?.toLowerCase().includes(value.toLowerCase()));
    setcompetitorFilter(value)
  };



  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader />; }
  if (!data?.medallist) { return <NotAvailable /> }

  //Create Object as data from getScheduleDays in order to use in SelectorDay,DayList
  let itemDates = { competition_schedule: [] }

  let tempDates =  groupByDate( data?.medallist,"medal_date")
  for (const [key, value] of Object.entries(tempDates)) {
    itemDates.competition_schedule.push({ date: key })
  }
  
  
  return (<>

    <PageHeader title={header} />
    <div className='mirs-page-container'>
      <Stack direction="horizontal" className="selectors-container">
        <SelectorDay daysItems={itemDates} page="medallists"/>
        <SelectorDiscipline display_type="combo" page="medallists" />
        <Selector_Event page="medallists" />
        <SelectorNoc page="medallists" />
        <SelectorMedal page="medallists" />
        <div className="d-flex">
          <input type="text" className="form-control" name="Competitor" id="Competitor" placeholder="Competitor" onChange={handleOnChange} />
        </div>
      </Stack>

      {dataState && <MedallistsTable data={dataState} key={`medallists`} />}

    </div>
  </>
  )





};


export default Medallists

